import { ButtonLink } from '@components/ui/Button'
import { FIT_FINDER_HASH } from '@consts/index'
import { getUserSavedFitData } from '@helpers/session/user'
import useIsReactClient from '@helpers/hooks/useIsReactClient'
import CartMenuIcon from '@components/Header/shared/CartMenuIcon'
import { ReactComponent as SearchIcon } from '@svgs/keyline/search.svg'
import styles from './styles.module.scss'
import { CartEvent } from '@components/Header'
import { getLink, prefixLocale } from '@helpers/env'
import { analytics } from '@helpers/analytics'
import { HEADER_ANALYTICS_EVENT_NAMES } from '@components/Header/consts'
import { useRouter } from 'next/router'
import { useLogin } from '@api/accounts/auth/hooks/useLogin'
import { ACCOUNT_PAGE_NAME } from '@api/accounts/auth/consts'
import AccountMenuIcon from '@components/Header/shared/AccountMenuIcon'

type SecondaryNavLinksProps = {
  onCartOpen: (e: CartEvent['event']) => void
}

export default function SecondaryNavLinks({
  onCartOpen
}: SecondaryNavLinksProps) {
  const { login, isLoggedIn } = useLogin()
  const router = useRouter()
  const userHasSavedFitCookies = getUserSavedFitData()
  const isReactClient = useIsReactClient()
  const userHasSavedFit = userHasSavedFitCookies && isReactClient

  const isSearchDrawerOpen = router.asPath?.includes('/pages/search')
  const isAccountPage = router.asPath?.includes('/account')

  const handleClickAccountIcon = () => {
    if (isLoggedIn) {
      const accountUrl = `${prefixLocale()}/${ACCOUNT_PAGE_NAME}?page=overview`
      router.push(accountUrl)
    } else {
      login()
    }
  }

  return (
    <div className={styles.DesktopHeader__secondaryLinks}>
      <ButtonLink
        href={`#${FIT_FINDER_HASH}`}
        rawHref={true}
        data-testid="fitfinder-desktop-nav-button"
        variant="primary_outline"
        size="small"
        classes={styles.fitFinderMenuLink}
        onClick={() =>
          analytics('Click', {
            category: HEADER_ANALYTICS_EVENT_NAMES.category.nav,
            label: 'My Fit'
          })
        }
      >
        {userHasSavedFit ? 'My Fit' : 'Find your Fit'}
      </ButtonLink>

      <a
        className={`${styles.DesktopHeader__searchIcon} ${
          isSearchDrawerOpen ? styles.DesktopHeader__searchIcon_active : ''
        }`}
        href={getLink('/pages/search')}
        onClick={() => {
          analytics('Click', {
            category: 'Search',
            action: 'Open',
            label: 'Desktop'
          })
        }}
      >
        <SearchIcon />
      </a>

      <button
        className={`${styles.DesktopHeader__accountIcon} ${
          isAccountPage ? styles.DesktopHeader__accountIcon_active : ''
        }`}
        data-testid="account-desktop-nav-button"
        onClick={() => {
          analytics('Click', {
            category: HEADER_ANALYTICS_EVENT_NAMES.category.nav,
            label: 'My Account'
          })
          handleClickAccountIcon()
        }}
      >
        <AccountMenuIcon isLoggedIn={isLoggedIn} />
      </button>

      <button className={styles.DesktopHeader__cartIcon} onClick={onCartOpen}>
        <span>
          <CartMenuIcon />
        </span>
      </button>
    </div>
  )
}
